<ng-container *transloco="let t; read: getReadValue()">
  <div class="invalid-feedback d-block" *ngIf="isFieldInvalid(form, field, 'required')">
    {{ t('required') }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="isFieldInvalid(form, field, 'email')">
    {{ t('valid') }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="isFieldInvalid(form, field, 'minlength')">
    {{ t('minLength', { limit: MinLengths[field] }) }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="isFieldInvalid(form, field, 'maxlength')">
    {{ t('maxLength', { limit: MaxLengths[field] }) }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="field === 'lastName' && isFieldInvalid(form, field, 'combinedLength')">
    {{ t('maxFullNameLength') }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="isFieldInvalid(form, field, 'pattern')">
    <!-- @ts-ignore -->
    {{ t('valid', field === 'postcode' ? { format: getErrorMessage(form, field, 'pattern') } : undefined) }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="isFieldInvalid(form, field, 'equalTo')">
    {{ t('mismatch') }}
  </div>
  <div class="invalid-feedback d-block" *ngIf="patternMatchesError$ | async as patternMatchesError">
    {{ patternMatchesError }}
  </div>
</ng-container>
